import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

// import VeeValidate from 'vee-validate'
// import zhTW from 'vee-validate/dist/locale/zh_TW.json'

// import i18n from '@/libs/i18n'
// import VueSocketIO from 'vue-socket.io'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/font-awesome-icon'
import '@/libs/tour'

// import '@/libs/antd'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
// Vue.use(i18n)
// Vue.use(VeeValidate, {
//   events: 'input|blur',
//   i18n,
//   dictionary: {
//     zhTW,
//   },
// })

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'https://localhost:5000',
// }))

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App),
}).$mount('#app')
